import { client } from "src/services/client";
import { SchoolView } from "src/types/school.type";
import { Nullable } from "src/utils";

export const fetchSchools = (query: Nullable<string>) =>
    client.get<{ schools: SchoolView[] }>(`/school?${query}`).then((res) => res.data);
